<div class="newegg-overlay" *ngIf="showShare">
  <div id="tsparticles"></div>
  <div class="card">
    <div class="close">
      <fa-icon [icon]="['fas', 'times-circle']" (click)="closeShare()"></fa-icon>
    </div>
    <div class="card-content" *ngIf="!collectedKryptomon">
      <img src="./assets/img/Home/{{modalImage}}" class="egg-pic" />
      <div class="modal-text">
        <p>{{modalTitle}}</p>
        <p>{{modalContent}}</p>
        <div (click)="doAction()" *ngIf="!isLoadingBuy" class="signup-btn">{{modalCta}}</div>
        <div class="lds-ripple" *ngIf="isLoadingBuy">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex flex-row content_display dashboard">
  <div class="col">
    <div class="card" [ngClass]="{'disabled': disabled[0]}" (click)="showModal('airdrop')">
      <div class="card-content">
        <img src="./assets/img/Home/coin.png" />
        <p>Physital NFT Campaign</p>
      </div>
    </div>
    <div class="card card-error" *ngIf="disabled[0]">
      <div class="card-content">
        <img src="./assets/img/Icon/Info.png" />
        <span>No airdrop to claim</span>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card" [ngClass]="{'disabled': availableCryptoComClaims.length == 0}" (click)="claimCryptoCom()">
      <div class="card-content">
        <img src="./assets/img/Home/crypto-com-coin-cro-logo.png" style="padding: 20px"/>
        <p>Crypto.com</p>
        <p *ngIf="availableCryptoComClaims.length > 0">{{availableCryptoComClaims.length}} NFTs</p>
      </div>
    </div>
    <div class="card card-error" *ngIf="availableCryptoComClaims.length == 0">
      <div class="card-content">
        <img src="./assets/img/Icon/Info.png" />
        <span>Nothing to claim</span>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card" [ngClass]="{'disabled': disabled[2]}" (click)="showModal('sale')">
      <div class="card-content">
        <img src="./assets/img/Home/egg-hunt.png" />
        <p>Egg Hunt KMON coin Airdrop</p>
      </div>
    </div>
    <div class="card card-error" *ngIf="disabled[2]">
      <div class="card-content">
        <img src="./assets/img/Icon/Info.png" />
        <span>Nothing to claim</span>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card" [ngClass]="{'disabled': disabled[3]}" (click)="claimHunt()">
      <div class="card-content">
        <img src="./assets/img/Home/egg-hunt.png" />
        <p>Treasure Hunt Egg Drop</p>
      </div>
    </div>
    <div class="card card-error" *ngIf="disabled[3]">
      <div class="card-content">
        <img src="./assets/img/Icon/Info.png" />
        <span>Nothing to claim</span>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card" [ngClass]="{'disabled': disabled[4]}" (click)="claimBNB()">
      <div class="card-content">
        <img src="./assets/img/Home/bsc-logo.png" />
        <p>BNB Chain Giveway</p>
      </div>
    </div>
    <div class="card card-error" *ngIf="disabled[4]">
      <div class="card-content">
        <img src="./assets/img/Icon/Info.png" />
        <span>Nothing to claim</span>
      </div>
    </div>
  </div>
</div>